/**
 * Get the questions and answers for each section
 * If no section is provided then all question are returned
 *
 * @param {string} section Current section
 * @param {array} surveyData Array with the survey data
 * @return {array}
 */
export function getQuestions(section, surveyData) {
  let dataArray = []
  surveyData[0]['pages'].map(question => {
    if (section) {
      if (question.section === section) {
        dataArray.push(question)
      }
    } else {
      dataArray.push(question)
    }
  })
  return dataArray
}

/**
 * Get the questions and answers for each section
 *
 * @param {array} surveyData Array with the survey data
 * @return {array}
 */
export function getSections(surveyData) {
  return [...new Set(surveyData[0]['pages'].map(data => data.section))]
}
